// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const OrganizationsIcon = createSvgIcon(
  <svg width={24} height={24} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 6.26a2.77 2.77 0 1 1 0 5.54 2.77 2.77 0 0 1 0-5.54m-5.54 2q.65 0 1.21.33c-.12 1.12.2 2.25.89 3.14A2.4 2.4 0 0 1 6.46 13a2.38 2.38 0 1 1 0-4.75m11.08 0a2.38 2.38 0 1 1 0 4.75 2.4 2.4 0 0 1-2.1-1.28c.69-.9 1-2.02.89-3.14q.56-.33 1.21-.33m-10.69 8.1c0-1.63 2.31-3 5.15-3s5.15 1.33 5.15 3v1.39H6.85zM2.5 17.74v-1.19c0-1.1 1.5-2 3.52-2.29-.5.59-.76 1.33-.75 2.09v1.39zm19 0h-2.77v-1.39c.01-.76-.25-1.5-.73-2.09 2 .27 3.52 1.19 3.52 2.29z" />
  </svg>,
  "Organizations",
);
export default OrganizationsIcon;
